import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import Landing from './components/Landing';
import CategoryPage from './components/CategoryPage';
import CartPage from './components/CartPage';
import ConfirmationPage from './components/ConfirmationPage';
import PrivacyNotice from './components/PrivacyNotice';
import MiniCartBar from './components/MiniCartBar';
import ProductModal from './components/ProductModal';
import { CartProvider } from './context/CartContext';
import { ThemeProvider } from './context/ThemeContext';
import { products } from './mock';
import { initAnalytics, trackPageView, trackProductView } from './lib/analytics';
import { getPageMeta } from './lib/pageMeta';

function App() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    const { title, description } = getPageMeta(location.pathname);
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
    trackPageView(location.pathname, title);
    // React Router no resetea el scroll al navegar entre rutas (a diferencia de una
    // navegación de página completa) — sin esto, si el usuario estaba scrolleado hacia
    // abajo en la página anterior, la ruta nueva carga en esa misma posición de scroll
    // en vez de arriba (ej. "Ver mi carrito" aterrizaba a media pantalla o en el footer).
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleOpenProduct = (productOrId) => {
    const found = typeof productOrId === 'string'
      ? products.find((p) => p.id === productOrId) || null
      : productOrId;
    setSelectedProduct(found);
    trackProductView(found);
  };

  return (
    <ThemeProvider>
      <CartProvider>
        <div className="App q-page">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route
              path="/gorras"
              element={<CategoryPage category="gorras" onOpenProduct={handleOpenProduct} />}
            />
            <Route
              path="/lentes"
              element={<CategoryPage category="lentes" onOpenProduct={handleOpenProduct} />}
            />
            <Route
              path="/joyeria"
              element={<CategoryPage category="joyeria" onOpenProduct={handleOpenProduct} />}
            />
            <Route
              path="/van-cleef"
              element={<CategoryPage category="van-cleef" onOpenProduct={handleOpenProduct} />}
            />
            <Route
              path="/conjuntos"
              element={<CategoryPage category="conjuntos" onOpenProduct={handleOpenProduct} />}
            />
            <Route
              path="/emprendedor"
              element={<CategoryPage category="emprendedor" onOpenProduct={handleOpenProduct} />}
            />
            <Route
              path="/carrito"
              element={<CartPage onOpenProduct={handleOpenProduct} />}
            />
            <Route
              path="/gracias"
              element={<ConfirmationPage onOpenProduct={handleOpenProduct} />}
            />
            <Route
              path="/privacidad"
              element={<PrivacyNotice onOpenProduct={handleOpenProduct} />}
            />
            {/* Rutas que ya no existen (/prueba-pago, /sorteo, /cajitas…) o mal escritas: a
                la portada en vez de una página en blanco. */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

          <MiniCartBar />

          <ProductModal
            product={selectedProduct}
            open={!!selectedProduct}
            onClose={() => setSelectedProduct(null)}
          />
        </div>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
